import { FC, HTMLAttributes } from "react";
import clsx from "classnames";
import { useStyles } from "./Icon.style";
interface IIconProps {
  name?: string;
  size?: number;
}

export const Icon: FC<IIconProps & HTMLAttributes<HTMLSpanElement>> = ({
  name,
  size = 24,
  ...otherProps
}) => {
  const classes = useStyles();

  if (!name) return null;

  // Decorative unless labelled or clickable
  const isNamed = !!(otherProps["aria-label"] || otherProps["aria-labelledby"]);
  const a11yProps =
    isNamed || otherProps.onClick
      ? { role: otherProps.onClick ? "button" : "img" }
      : { "aria-hidden": true };

  return (
    <span
      {...a11yProps}
      {...otherProps}
      style={{
        ...otherProps.style,
        fontSize: size,
        lineHeight: `${size}px`,
      }}
      className={clsx(otherProps.className, classes.root, name)}
    />
  );
};
